"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _awaitAsyncGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/awaitAsyncGenerator"));

var _wrapAsyncGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/wrapAsyncGenerator"));

var _asyncIterator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncIterator"));
/**
 * Executes the query represented by a path.
 *
 * Requires:
 * - a queryEngine property in the path settings
 * - a sparql property on the path proxy
 */


var ExecuteQueryHandler =
/*#__PURE__*/
function () {
  function ExecuteQueryHandler() {
    _classCallCheck(this, ExecuteQueryHandler);
  }

  _createClass(ExecuteQueryHandler, [{
    key: "handle",
    value: function handle(pathData, path) {
      var _this = this;

      return (0, _wrapAsyncGenerator2.default)(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var queryEngine, query, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, bindings;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // Retrieve the query engine and query
                queryEngine = pathData.settings.queryEngine;

                if (queryEngine) {
                  _context.next = 3;
                  break;
                }

                throw new Error("".concat(pathData, " has no queryEngine setting"));

              case 3:
                _context.next = 5;
                return (0, _awaitAsyncGenerator2.default)(path.sparql);

              case 5:
                query = _context.sent;

                if (query) {
                  _context.next = 8;
                  break;
                }

                throw new Error("".concat(pathData, " has no sparql property"));

              case 8:
                // Extract the term from every query result
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _context.prev = 10;
                _iterator = (0, _asyncIterator2.default)(queryEngine.execute(query));

              case 12:
                _context.next = 14;
                return (0, _awaitAsyncGenerator2.default)(_iterator.next());

              case 14:
                _step = _context.sent;
                _iteratorNormalCompletion = _step.done;
                _context.next = 18;
                return (0, _awaitAsyncGenerator2.default)(_step.value);

              case 18:
                _value = _context.sent;

                if (_iteratorNormalCompletion) {
                  _context.next = 26;
                  break;
                }

                bindings = _value;
                _context.next = 23;
                return _this.extractTerm(bindings, pathData);

              case 23:
                _iteratorNormalCompletion = true;
                _context.next = 12;
                break;

              case 26:
                _context.next = 32;
                break;

              case 28:
                _context.prev = 28;
                _context.t0 = _context["catch"](10);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 32:
                _context.prev = 32;
                _context.prev = 33;

                if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                  _context.next = 37;
                  break;
                }

                _context.next = 37;
                return (0, _awaitAsyncGenerator2.default)(_iterator.return());

              case 37:
                _context.prev = 37;

                if (!_didIteratorError) {
                  _context.next = 40;
                  break;
                }

                throw _iteratorError;

              case 40:
                return _context.finish(37);

              case 41:
                return _context.finish(32);

              case 42:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[10, 28, 32, 42], [33,, 37, 41]]);
      }))();
    }
    /**
     * Extracts the first term from a query result binding as a new path.
     */

  }, {
    key: "extractTerm",
    value: function extractTerm(binding, pathData) {
      // Extract the first term from the binding map
      if (binding.size !== 1) throw new Error('Only single-variable queries are supported');
      var term = binding.values().next().value; // Each result is a new path that starts from the given term as subject

      return pathData.extendPath({
        subject: term
      }, null);
    }
  }]);

  return ExecuteQueryHandler;
}();

exports.default = ExecuteQueryHandler;